// reducer.js
import {
  GET_SOURCE_SETTINGS_NOTES,
  GET_SOURCE_SETTINGS_NOTES_SUCCESS,
  GET_SOURCE_SETTINGS_NOTES_ERROR,
  CREATE_SOURCE_SETTINGS_NOTES,
  CREATE_SOURCE_SETTINGS_NOTES_SUCCESS,
  CREATE_SOURCE_SETTINGS_NOTES_ERROR,
  UPDATE_SOURCE_SETTINGS_NOTES,
  UPDATE_SOURCE_SETTINGS_NOTES_SUCCESS,
  UPDATE_SOURCE_SETTINGS_NOTES_ERROR,
  DELETE_SOURCE_SETTINGS_NOTES,
  DELETE_SOURCE_SETTINGS_NOTES_SUCCESS,
  DELETE_SOURCE_SETTINGS_NOTES_ERROR,
  BULK_CREATE_SOURCE_SETTINGS_NOTES,
  BULK_CREATE_SOURCE_SETTINGS_NOTES_SUCCESS,
  BULK_CREATE_SOURCE_SETTINGS_NOTES_ERROR,
} from "./actionTypes";

const initialState = {
  source_settings_notes_loading: false,
  source_settings_notes_error: null,
  source_settings_notes: [],
};

const sourceSettingsNotesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SOURCE_SETTINGS_NOTES:
    case CREATE_SOURCE_SETTINGS_NOTES:
    case UPDATE_SOURCE_SETTINGS_NOTES:
    case DELETE_SOURCE_SETTINGS_NOTES:
    case BULK_CREATE_SOURCE_SETTINGS_NOTES:
      return {
        ...state,
        source_settings_notes_loading: true,
        source_settings_notes_error: null,
      };

    case GET_SOURCE_SETTINGS_NOTES_SUCCESS:
      return {
        ...state,
        source_settings_notes_loading: false,
        source_settings_notes: action.payload,
      };
    case CREATE_SOURCE_SETTINGS_NOTES_SUCCESS:
      return {
        ...state,
        source_settings_notes_loading: false,
        source_settings_notes: [...state.source_settings_notes, action.payload],
      };
    case UPDATE_SOURCE_SETTINGS_NOTES_SUCCESS:
      return {
        ...state,
        source_settings_notes_loading: false,
        source_settings_notes: state.source_settings_notes.map((source_settings_note) => {
          if (source_settings_note.id === action.payload.id) {
            return action.payload
          }
          return source_settings_note
        }),
      };
    case DELETE_SOURCE_SETTINGS_NOTES_SUCCESS:
      return {
        ...state,
        source_settings_notes_loading: false,
        source_settings_notes: state.source_settings_notes.filter(
          (source_settings_note) => source_settings_note.id !== action.payload.id
        )
      };
    case BULK_CREATE_SOURCE_SETTINGS_NOTES_SUCCESS:
      return {
        ...state,
        source_settings_notes_loading: false,
        source_settings_notes: [...state.source_settings_notes, ...(Array.isArray(action.payload) ? action.payload : [])],
      };

    case GET_SOURCE_SETTINGS_NOTES_ERROR:
    case CREATE_SOURCE_SETTINGS_NOTES_ERROR:
    case UPDATE_SOURCE_SETTINGS_NOTES_ERROR:
    case DELETE_SOURCE_SETTINGS_NOTES_ERROR:
    case BULK_CREATE_SOURCE_SETTINGS_NOTES_ERROR:
      return {
        ...state,
        source_settings_notes_loading: false,
        source_settings_notes_error: action.payload,
      };

    default:
      return state;
  }
};

export default sourceSettingsNotesReducer;
